<template lang="pug">
template(v-if="isTop")
  .smx-form-item(
    :style="{ 'grid-column': props.fullWidth ? '1 / -1' : undefined }"
  )
    .label.flex.w-full.items-end.justify-between.gap-2
      .flex.items-center.gap-1
        label.smx-label(
          :class="{ required: props.required, 'self-center': props.center }",
          :style="{ 'min-width': props.minWidth }"
        ) {{ props.label }}
        SmxInfo(
          v-if="props.description",
          :title="props.label || ''",
          :content="props.description"
        )
      .label-action
        slot(name="label-action")
    div(class="max-md:mb-3", :aria-label="props.label || ''")
      slot
template(v-else)
  .label
    label.smx-label(
      :class="{ 'md:text-right': true, required: props.required, 'self-center': props.center }",
      :style="{ 'min-width': props.minWidth }"
    ) {{ props.label }}
    SmxInfo(
      v-if="props.description",
      :title="props.label || ''",
      :content="props.description"
    )
  div(class="max-md:mb-3", :aria-label="props.label || ''")
    slot
</template>

<script setup lang="ts">
import { computed, inject } from "vue";
import SmxInfo from "@shared/components/elements/SmxInfo.vue";
import { smxFormLayoutKey } from "@shared/components/elements/smxFormLayout";

const props = defineProps<{
  label?: string;
  description?: string;
  required?: boolean;
  minWidth?: number;
  center?: boolean;
  fullWidth?: boolean;
}>();

const formLayout = inject(smxFormLayoutKey);
const isTop = computed(() => formLayout?.labelPosition.value === "top");
</script>

<style scoped>
.smx-label {
  word-break: break-all;
}
</style>
